import { formatDateStr, getUnitByCount } from '@gp/utils/common';
import moment from 'moment';
import React from 'react';
import Header from '../Header';
import Milestones from '../Milestones';

import type { ICalendarTableDTO } from '@gp/types/calendar';
import type { TableColumn } from 'tea-component';

export const PROJECT_COLUMN_WIDTH = 220;

const UNIT_MAP = {
  project: {
    single: 'Project',
    multiple: 'Projects',
  },
  milestone: {
    single: 'Milestone',
    multiple: 'Milestones',
  },
};

export const getProjectNumText = (num?: any): string => {
  const numTmp = Number.parseInt(num, 10);
  if (Number.isNaN(numTmp)) return '';
  return getUnitByCount('project', numTmp, UNIT_MAP);
};

const getMilestoneNumText = (num?: any): string => {
  const numTmp = Number.parseInt(num, 10);
  if (Number.isNaN(numTmp)) return '';
  const unitText = getUnitByCount('milestone', numTmp, UNIT_MAP);
  return `${num} ${unitText}`;
};

/**
 * 根据projects数据，生成date于所有projects在date时间段内的milestones数量总数 的元组 集合
 * 集合中的元素是元组，元组第一个元素是string，代表date，第二个元素是number，代表所有projects在date时间段内的milestones数量总数
 * @param projects projects数据，接口返回的
 * @returns date、milestones数量元组集合
 */
const getDateHeaders = (projects?: ICalendarTableDTO[]): [string, number][] => {
  if (!Array.isArray(projects) || !projects.length) return [];
  // 键为date、值为所有projects在date对应的时间段内的milestones数量
  const map: Record<string, number> = {};
  for (const project of projects) {
    const { details } = project || {};
    if (!Array.isArray(details) || !details.length) continue;
    for (const detail of details) {
      const { date, milestones } = detail || {};
      if (!date) continue;
      // 累加
      map[date] = (map[date] || 0) + (milestones?.length || 0);
    }
  }
  // 按date升序排序
  return Object.entries(map).sort((a, b) => {
    const aM = moment(a[0]);
    const bM = moment(b[0]);
    return aM.isAfter(bM) ? 1 : -1;
  });
};

export const getDateColumns = (
  records: ICalendarTableDTO[],
  props: {
    tableWidths: number;
    fullScreenContent: React.RefObject<HTMLDivElement | null>;
  },
): TableColumn<ICalendarTableDTO>[] => {
  const { tableWidths, fullScreenContent } = props || {};
  const dateHeaders = getDateHeaders(records);
  return dateHeaders.map((dateHeader) => {
    const [date, num] = dateHeader || [];
    const title = formatDateStr(date, 'YYYY-MM');
    const text = getMilestoneNumText(num);
    return {
      key: date,
      width: tableWidths,
      header: <Header title={title} text={text} />,
      render: (cvm) => {
        const { project, studio, bo, details } = cvm || {};
        const detail = details?.find((detail) => detail?.date === date);
        const { milestones } = detail || {};
        if (!Array.isArray(milestones) || !milestones.length) return null;
        return (
          <Milestones
            fullScreenContent={fullScreenContent}
            project={project}
            studio={studio}
            bo={bo}
            data={milestones}
            cvmData={cvm}
          />
        );
      },
    };
  });
};
